import { CoursesTypePicker } from "src/components/NewComponents/Creator/ContentPicker/CoursesTypePicker";

import { LayoutWithSearch } from "src/containers/Layouts/LayoutWithSearch";

export function CourseTypePickerContainer() {
	return (
		<LayoutWithSearch>
			<CoursesTypePicker />
		</LayoutWithSearch>
	);
}
